module.exports = __webpack_public_path__ + "img/Journal.bc10e62a.svg";